module.exports = __webpack_public_path__ + "static/media/nByMnh148e.75608810.jpg";